import React from 'react';
import { formatPrice } from '../../utils';


const CashTransferInstruction = (props) => {
    return (
        <div className="steps-payment">
            <div className="steps">
                <div className="step">
                    <strong>1 - </strong>
                    <span>Acesse o APP ou o site do {props.purchase.payment.bank_name}.</span>
                </div>
                <div className="step">
                    <strong>2 - </strong>
                    <span>No menu de serviços, selecione Transferência Bancária</span>
                </div>
                <div className="step">
                    <strong>3 - </strong>
                    <span>Informe a agência: {props.purchase.payment.active_safetypay.extra.instructions.beneficiary_branch} e conta-corrente: {props.purchase.payment.active_safetypay.extra.instructions.beneficiary_account}</span>
                </div>
                <div className="step">
                    <strong>4 - </strong>
                    <span>Confirme o nome do favorecido:  {props.purchase.payment.active_safetypay.extra.instructions.beneficiary_name}</span>
                </div>
                <div className="step">
                    <strong>5 - </strong>
                    <span>Efetue o pagamento no valor exato de R$ {formatPrice(props.purchase.price)}</span>
                </div>
                <div className="step">
                    <strong>6 - </strong>
                    <span>PRONTO! O pagamento do seu pedido será confirmado para Seguros Promo</span>
                </div>
            </div>
            <div className="step-box">

                <div className="step-box-header">
                    <b>De: sua conta</b>
                    <div className="bank-image">
                        <img
                            src={props.purchase.payment.bank_img_path}
                            className="img-bank"
                            alt={props.purchase.payment.bank_name}
                        />
                    </div>
                </div>
                <div className="step-box-cpf">
                    CPF: {props.purchase.payment.active_safetypay.holder_cpf}
                </div>
                <hr />
                <div className="step-box-header">
                    <b>Para: conta do PayMee</b>
                    <div className="bank-image">
                        <img
                            src={props.purchase.payment.bank_img_path}
                            className="img-bank"
                            alt={props.bank_name}
                        />
                    </div>
                </div>

                <div className="step-bank-branch">
                    Agência: {props.purchase.payment.active_safetypay.extra.instructions.beneficiary_branch}
                    <img
                        className="icon-copy"
                        id="agency-copy"
                        src="/assets/images/icon-copy.svg"
                        alt="icone para copiar agência"
                        onClick={() => { navigator.clipboard.writeText(props.purchase.payment.active_safetypay.extra.instructions.beneficiary_branch) }}
                    />
                </div>
                <div className="step-bank-account">
                    Conta Corrente: {props.purchase.payment.active_safetypay.extra.instructions.beneficiary_account}
                    <img
                        className="icon-copy"
                        id="account-copy"
                        src="/assets/images/icon-copy.svg"
                        alt="icone para copiar conta"
                        onClick={() => { navigator.clipboard.writeText(props.purchase.payment.active_safetypay.extra.instructions.beneficiary_account) }}
                    />
                </div>
                <div className="step-bank-beneficiary">
                    Favorecido: <i>{props.purchase.payment.active_safetypay.extra.instructions.beneficiary_name}</i>
                </div>
                <div className="step-bank-document">
                    CNPJ: {props.purchase.payment.active_safetypay.extra.instructions.beneficiary_document}
                </div>
                <div className="step-bank-price">
                    Valor a ser pago: <b>R$ {formatPrice(props.purchase.price)}</b>
                </div>

            </div>
        </div >
    )
}

export default CashTransferInstruction;



// WEBPACK FOOTER //
// ./src/components/purchase_status/CashTransferInstruction.jsx